document.addEventListener("DOMContentLoaded", function() {

  const mainImage = document.querySelector('.product__media-item img');

  if (!mainImage) return;

  const container = mainImage.parentElement;

  // Setup container and image
  container.style.overflow = 'hidden';
  container.style.position = 'relative';
  mainImage.style.transition = 'transform 0.2s ease';
  mainImage.style.transformOrigin = 'center center';
  mainImage.style.cursor = 'zoom-in';

  // Function to start zoom
  function zoomImage(e) {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      mainImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      mainImage.style.transform = 'scale(1.8)'; // zoom level
  }

  // Start zoom on hover automatically
  container.addEventListener('mouseenter', function() {
      container.addEventListener('mousemove', zoomImage);
  });

  container.addEventListener('mouseleave', function() {
      mainImage.style.transform = 'scale(1)';
      mainImage.style.transformOrigin = 'center center';
      container.removeEventListener('mousemove', zoomImage);
  });

});

